import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { Contatto } from '../../../shared/interface';
import { Table } from 'primeng/table';
import { ConfirmationService } from 'primeng/api';
import { ConfirmPopup } from 'primeng/confirmpopup';

@Component({
  selector: 'app-contatti-backoffice',
  templateUrl: './contatti-backoffice.component.html',
  styleUrl: './contatti-backoffice.component.css'
})
export class ContattiBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService) {}

  @ViewChild("deleteContatto") deleteContatto!: ConfirmPopup;

  contatti: Contatto[] = [];
  loading: boolean = false;

  ngOnInit(): void {
    
    this.loading = true;

    this.apiService.setContatti();
    this.apiService.contattiChanged.subscribe({
      next: (data) => {
        this.contatti = [...data];
        this.loading = false;
      },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),      
    })
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenDeleteContatto(event: Event, contatto: Contatto) {        
    this.confirmationService.confirm({      
      target: event.target as EventTarget,
      message: `Sei sicuro di voler eliminare il contatto?`,
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteContatto(contatto.id).subscribe({          
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {  
            this.confirmationService.close()
            this.apiService.setContatti()
            this.apiService.message("success", "Eliminazione", "Il contatto è stato eliminato con successo")
          }
        })
      }
    });
  }

  onDeleteContatto() {
    this.deleteContatto.accept();
  }

  onAnnullaDeleteContatto() {
    this.deleteContatto.reject();
  }

}
